<div class="tw-px-4 tw-mb-4">
  <div class="tw-w-full tw-bg-orange-100 tw-rounded-2 tw-py-4">
    @if (changeHeading()) {
      <p class="tw-mb-4 tw-text-300 tw-font-bold tw-font-lexend tw-pl-4" i18n="@@theRealProblem">THE REAL PROBLEM</p>
    } @else {
      <p class="tw-mb-4 tw-text-300 tw-font-bold tw-font-lexend tw-pl-4" i18n="@@factorsAffectingYourSkin">FACTORS AFFECTING YOUR SKIN</p>
    }
    <div class="tw-w-full tw-flex tw-items-center tw-justify-between tw-mb-2">
      @for(item of rootCauses(); track $index) {
        <div class="tw-w-1/3 tw-h-18 tw-flex tw-flex-col tw-justify-start tw-items-center">
          <img class="tw-w-11 tw-mb-2" [src]="item.icon" alt="root cause">
          <p class="tw-leading-4 tw-text-center tw-text-300 tw-text-gray-800 tw-w-[90%]">{{ item.title ?? item.description }}</p>
        </div>
      }
    </div>
  </div>
</div>
